import { theme } from '@/utils/theme';

export const classes = {
  tableCell: 'py-0 px-0',
  skeleton: 'py-6',
};

export const styles = {
  skeleton: (delay: number, duration: number) => ({
    backgroundColor: theme.palette['grey-1'].main,
    '&:after': {
      animationDelay: `${delay}s`,
      animationDuration: `${duration}s`,
    },
  }),
};
